import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink } from "react-router-dom";
import {toast} from 'react-toastify';
import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import { isEmpty } from "../helper/common";
import config from '../helper/config';
import { userLogin } from "../Axios/user.axios";
import Subscriber from "../Layout/subscribe";
import {useNavigate} from 'react-router-dom';


const initform = {
    EmailId: '',
};

export default function Forgot() {

    useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, []);

      const [formdata, SetFormdata] = useState(initform);
      const [DisableStatus, SetDisableStatus] = useState(false)
  const [focusedfield, SetFocusedField] = useState([]);
  const [Error, SetError] = useState({});
   const navigate = useNavigate();

    const OnChange = (e) => {
        const { id, value } = e.target;
        // SetError({})
        SetFormdata({ ...formdata, ...{ [id]: value } });
    }

    const Validate = () => {
        let error = {};
        if(isEmpty(formdata?.EmailId)){
            error.EmailId = "Enter Email-Id"
        }
        else if(!config.EMAIL.test(formdata?.EmailId)){
            error.EmailId = "Enter Valid EmailId"
        }
        return error
    }

    const OnBlurFn = (e) => {
        const { id, value } = e.target;
        let error = Validate();
        Object.keys(error).map((currkey) => {
            if (currkey == id || focusedfield.includes(currkey)) {
            }
            else {
                delete error[currkey];
            }
        })
        if (focusedfield?.includes(id)) {
        }
        else {
            SetFocusedField([
                ...focusedfield,
                ...[id],
            ])
        }
        SetError(error);
    }

    const ForgotPassword = async () => {
        SetDisableStatus(true)
        if(!DisableStatus){
            let error = Validate();
            if (isEmpty(error)) {
                let senddata = formdata;
                senddata.Type = "forgotpassword";
                var Resp = await userLogin(senddata);
                console.log('userLogin_resp', Resp)
                if (Resp?.success == 'success') {
                    toast.success(Resp.msg, 1000)
                    navigate('/login')
                }
                else {
                    toast.error(Resp.msg, 1000);
                }
            }
            else {
                SetError(error);
            }
            SetDisableStatus(false)
        }
    }

    return (

        <>

            <div className="forgotpage">

                <Header />

                <section class="section">
                    <div className="container font-md">
                        <div className="container text-center customer-reset-password">
                            <h2 className="color-brand-1 mb-3">Forgot Password</h2>
                            <p className="font-md color-grey-500 mb-4">
                                {/* Iori is a Multipurpose Agency Laravel Script. It is a powerful, clean, modern, and fully responsive template. It is designed for agency, business, corporate, creative, freelancer, portfolio, photography, personal, resume, and any kind of creative fields. */}
                               Enter your email address below and we’ll send you a link to reset your password.If you don’t receive an email shortly, please check your spam folder or try again.
                                </p>
                            <form method="POST" class="row" action="">
                            <div class="col-lg-12">
                                <div class="form-group mb-4">
                                    <input class={focusedfield?.includes('EmailId') ? (Error?.EmailId ? "form-control icon-user is-invalid" : "form-control icon-user is-valid") : "form-control icon-user"} id="EmailId" name="email" type="email" placeholder="Enter Email" onBlur={(e)=>OnBlurFn(e)} onChange={(e)=>OnChange(e)}/>
                                    {Error?.EmailId && <p className="error-msg text-start">{Error.EmailId}</p>}
                                </div>
                                <div class="col-lg-12 mb-4">
                                    <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={()=>ForgotPassword()} disabled={DisableStatus}>Send Password Reset Link</button>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                </section>
                <Subscriber/>
                {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary"/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">   
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                <form action="" className="newsletter-form" novalidate="novalidate">
                                        <input type="email" name="email" placeholder="Enter your email..."/>
                                            <button className="btn btn-submit-newsletter" type="button">
                                             <FaArrowRight/>
                                                </button>
                                 </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <Footer />

            </div>

        </>
    );
}
